<!-- 404 Page not found -->
<app-status-state [logo]="BRAND.logo.error"
                  [heroContents]="appHeroContents"
                  [informationType]="INFORMATION_TYPES.error"
                  [links]="quickLinks"
                  (action)="router.navigate( [ URLS.root ] )"></app-status-state>
